import React from "react";
import { motion } from "framer-motion";
import "./ServicesCommon.scss";
import CommonService from "../../../assets/images/servicescommon.png";
import { FaLightbulb, FaUsersCog, FaChartLine } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const servicesData = [
  {
    icon: FaUsersCog,
    title: "Expert People",
    description: "We have amassed significant expertise across a wide range of industries.",
    delay: 0.1,
  },
  {
    icon: FaChartLine,
    title: "Fast Growing Process",
    description:
      "With our expertise and dedicated approach we help in growing our client business effectively.",
    delay: 0.2,
  },
  {
    icon: FaLightbulb,
    title: "Creative Ideas",
    description:
      "We have innovative and creative business ideas which help our clients to stay one step ahead.",
    delay: 0.3,
  },
];

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

const cardVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100, damping: 20 },
  },
};

const barVariants = {
  hidden: { width: 0 },
  visible: (custom) => ({
    width: `${custom.percent}%`,
    transition: {
      delay: custom.delay,
      duration: 1.5,
      ease: "easeOut",
    },
  }),
};

const barData = [
  { label: "Technology Adoption", percent: 92, delay: 0.8 },
  { label: "Client Satisfaction", percent: 90, delay: 1.0 },
  { label: "Project Completion Rate", percent: 85, delay: 1.2 },
  { label: "Business Growth Impact", percent: 95, delay: 1.4 },
];

const ServicesCommon = () => {
    const navigate = useNavigate(); 
  return (
    <div className="services-common-section-common">

      {/* Top Cards */}
      <motion.div
        className="services-cards-grid-common"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {servicesData.map((service, index) => (
          <motion.div key={index} className="service-card-common" variants={cardVariants}>
            <div className="card-icon-wrapper-common">
              <service.icon className="service-icon-common" />
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </motion.div>
        ))}
      </motion.div>

      {/* Content Row */}
      <div className="main-content-row-common">
        <div className="illustration-container-common"><img className="common-img" src={CommonService} alt="CommonService" /></div>
      
        <div className="content-and-bars-common">
          <motion.p className="section-tag-common" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
            WHY CHOOSE US
          </motion.p>

          <motion.h2 className="section-title-common">
            We Are Increasing Business Success With Technology
          </motion.h2>

          <motion.p className="section-subtitle-common">
            Over 8 years working in IT services developing software applications and mobile apps for clients all over the world.
          </motion.p>

          <div className="progress-bars-container-common">
            {barData.map((bar, index) => (
              <div key={index} className="progress-bar-item-common">
                <div className="bar-labels-common">
                  <span>{bar.label}</span>
                  <span>{bar.percent}%</span>
                </div>

                <div className="bar-track-common">
                  <motion.div
                    className="bar-fill-common"
                    custom={bar}
                    variants={barVariants}
                    initial="hidden"
                    whileInView="visible"
                  />
                </div>
              </div>
            ))}
          </div>

          <motion.button className="learn-more-button-common" onClick={ () => navigate("/contact-us")}>
            Learn More
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default ServicesCommon;
